import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ProgressBar from "../Elements/ProgressBar.js";

// components
import Button from "../Elements/Button.js";

export default function MediaPlayerTestimonial({ items, defaultOpened }) {
  const [open, setOpen] = React.useState(defaultOpened);
  const [oldInTransition, setOldInTransition] = React.useState(false);
  const [newInTransition, setNewInTransition] = React.useState(false);
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 0 : prev + 1));
    }, 100);

    if (progress === 100) {
      setOldInTransition(true);
      setTimeout(() => {
        setOpen((prev) => (prev + 1 >= items.length ? 0 : prev + 1));
      }, 500);
      setTimeout(() => {
        setOldInTransition(false);
        setNewInTransition(true);
      }, 600);
      setTimeout(() => {
        setNewInTransition(false);
      }, 1100);
    }
    return () => clearInterval(interval);
  }, [progress, items.length]);

  const toggleNew = (e, newOpen) => {
    setProgress(0);
    e.preventDefault();
    if (!newInTransition && !oldInTransition) {
      setOldInTransition(true);
      setTimeout(function () {
        setOpen(newOpen);
      }, 500);
      setTimeout(function () {
        setOldInTransition(false);
        setNewInTransition(true);
      }, 600);
      setTimeout(function () {
        setNewInTransition(false);
      }, 1100);
    }
  };

  return (
    <>
      <div className="px-4 relative w-full">
        <div className="mt-12">
          <div>
            {items.map((prop, key) => {
              return (
                <div
                  className={classnames(
                    "border rounded-lg p-6 transform duration-300 transition-all ease-in-out mx-auto",
                    {
                      hidden: key !== open,
                      block: key === open,
                      "opacity-0 scale-95": key === open && oldInTransition,
                      "opacity-100 scale-100": key === open && newInTransition,
                    }
                  )}
                  key={key}
                >
                   <div className="text-left relative">
                  <i className="fas fa-quote-left text-2xl text-gray-300 absolute -left-4 top-0"></i>
                  <p className="leading-relaxed text-blueGray-500 mb-4 ml-8 italic">
                    {prop.description}
                  </p>
                  <div className="flex items-start">
                    <div className="flex-1">
                      <div className="justify-between items-center">
                        <h4 className="font-semibold leading-tight mt-6">
                          {prop.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                  <ProgressBar bgcolor="rgb(14 165 233)"completed={progress} />
                </div>
              );
            })}
          </div>
          
          <div className="flex justify-center my-12">
            <Button
              color="white"
              onClick={(e) =>
                toggleNew(e, open - 1 < 0 ? items.length - 1 : open - 1)
              }
            >
              <i className="fas fa-chevron-left"></i>
            </Button>
            <Button
              color="white"
              onClick={(e) =>
                toggleNew(e, open + 1 > items.length - 1 ? 0 : open + 1)
              }
            >
              <i className="fas fa-chevron-right"></i>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

MediaPlayerTestimonial.defaultProps = {
  defaultOpened: 0,
  items: [],
};

MediaPlayerTestimonial.propTypes = {
  defaultOpened: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};
